/**
 * @flow
 * @relayHash d8e816e41bfb5f4955344fdc30ea19db
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExperimentGroupAdExplanation = "DEFAULT" | "NONE" | "SHOW_EXPLANATION" | "%future added value";
export type ExperimentGroupAnonSignIn = "ANONYMOUS_ALLOWED" | "AUTHED_USER_ONLY" | "NONE" | "%future added value";
export type ExperimentGroupOneAdForNewUsers = "DEFAULT" | "NONE" | "ONE_AD_AT_FIRST" | "%future added value";
export type ExperimentGroupReferralNotification = "COPY_A" | "COPY_B" | "COPY_C" | "COPY_D" | "COPY_E" | "NONE" | "NO_NOTIFICATION" | "%future added value";
export type ExperimentGroupSearchIntro = "INTRO_A" | "INTRO_HOMEPAGE" | "NONE" | "NO_INTRO" | "%future added value";
export type ExperimentGroupThirdAd = "NONE" | "THREE_ADS" | "TWO_ADS" | "%future added value";
export type ExperimentGroupVariousAdSizes = "NONE" | "STANDARD" | "VARIOUS" | "%future added value";
export type UpdateUserExperimentGroupsInput = {|
  userId: string,
  experimentGroups?: ?ExperimentGroups,
  clientMutationId?: ?string,
|};
export type ExperimentGroups = {|
  anonSignIn?: ?ExperimentGroupAnonSignIn,
  variousAdSizes?: ?ExperimentGroupVariousAdSizes,
  thirdAd?: ?ExperimentGroupThirdAd,
  oneAdForNewUsers?: ?ExperimentGroupOneAdForNewUsers,
  adExplanation?: ?ExperimentGroupAdExplanation,
  searchIntro?: ?ExperimentGroupSearchIntro,
  referralNotification?: ?ExperimentGroupReferralNotification,
|};
export type UpdateUserExperimentGroupsMutationVariables = {|
  input: UpdateUserExperimentGroupsInput
|};
export type UpdateUserExperimentGroupsMutationResponse = {|
  +updateUserExperimentGroups: ?{|
    +user: ?{|
      +id: string
    |}
  |}
|};
export type UpdateUserExperimentGroupsMutation = {|
  variables: UpdateUserExperimentGroupsMutationVariables,
  response: UpdateUserExperimentGroupsMutationResponse,
|};
*/


/*
mutation UpdateUserExperimentGroupsMutation(
  $input: UpdateUserExperimentGroupsInput!
) {
  updateUserExperimentGroups(input: $input) {
    user {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserExperimentGroupsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserExperimentGroups",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserExperimentGroupsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateUserExperimentGroupsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateUserExperimentGroupsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateUserExperimentGroupsMutation",
    "id": null,
    "text": "mutation UpdateUserExperimentGroupsMutation(\n  $input: UpdateUserExperimentGroupsInput!\n) {\n  updateUserExperimentGroups(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba9b4c9a172d4cc274966a954481fb63';
module.exports = node;
